var btnIcon = {
  "btnIcon": {
    "alignItems": "center",
    "display": "inline-flex",
    "minWidth": "2.625rem",
    "justifyContent": "center",
    "paddingRight": "1.875rem",
    "paddingLeft": "1.875rem",
    "&::before": {
      "WebkitFontSmoothing": "antialiased",
      "WebkitTextStroke": "0",
      "MozOsxFontSmoothing": "grayscale",
      "backfaceVisibility": "hidden",
      "display": "inline-block",
      "fontFamily": "\"dls-icons-2.31.2\"",
      "fontStyle": "normal",
      "fontSize": "1.75rem",
      "fontWeight": "normal",
      "fontVariant": "normal",
      "textTransform": "none",
      "position": "relative",
      "speak": "none",
      "verticalAlign": "middle"
    }
  },
  "btnIcon_btnInline": {
    "display": "inline-flex !important",
    "paddingRight": "0.625rem",
    "paddingLeft": "0.625rem"
  },
  "btnIcon_btnSm": {
    "paddingRight": "1.25rem",
    "paddingLeft": "1.25rem",
    "&::before": {
      "fontSize": "1.375rem"
    }
  },
  "btnIcon_btnSm_btnInline": {
    "paddingRight": "0.375rem",
    "paddingLeft": "0.375rem"
  },
  "btnIcon_span": {
    "display": "inline-block",
    "verticalAlign": "middle",
    "paddingLeft": "10px"
  }
};

export { btnIcon as default };
